import React, { useCallback, useId } from 'react'

import type { AdapterKitControlProps } from 'components/formKit/types'
import { isMixed } from 'components/uiKit/KitUtils'
import { t } from 'services/Translation'
import { testPropsEl } from 'utils/test/qaData'

import * as s from './FieldExternalFile.module.scss'

interface IExternalFileProps {
  value: File | null
  name: string
}

const ExternalFile = ({
  name,
  onChange,
  ...rest
}: AdapterKitControlProps<IExternalFileProps, File | null>) => {
  const id = useId()
  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const file = event.target.files?.[0]
      return onChange?.({ name, value: file || null })
    },
    [name, onChange],
  )

  return (
    <div className={s.root}>
      <input
        className={s.input}
        id={id}
        name={name}
        onChange={handleChange}
        type='file'
        {...testPropsEl('externalFile', {
          value: isMixed(rest.value) ? undefined : rest.value,
          name,
        })}
      />
      <label className={s.label} htmlFor={id}>
        {!isMixed(rest.value) && rest.value?.name ? (
          <span>{(rest.value as File).name}</span>
        ) : (
          <span>{t('input.label.upload')}</span>
        )}
      </label>
    </div>
  )
}

export default React.memo(ExternalFile) as typeof ExternalFile
